import { Col, Text } from 'components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Paragraph = (props) => <Text marg="39px 0 0" {...props} />;
const StopTheHate = ({}) => {
  const { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Col wid="100vw" center marg="0 0 100px">
      <Col noFlex wid={isMobile ? 'calc(100vw - 32px)' : '1140px'} center>
        <Text wid="100%" h1 center marg="0 0 32px">
          Stop The Hate
        </Text>

        <Paragraph>An Open Letter to the Athletic Community</Paragraph>

        <Paragraph>
          Once heralded as online destinations to create like-minded connections, for,
          conversations, group meet ups and learning, public social media have descended into
          bastions of hate, chaos, disrespect, and sheer degenerative behavior with human dignity
          seeming to have fallen by the wayside. The outrageous actions have forced some athletes,
          celebrities, and people of good will to begin abandoning social media platforms.
        </Paragraph>

        <Paragraph>
          English Football found it necessary to boycott social media in response to persistent,
          online racist abuse of players.
        </Paragraph>

        <Paragraph>
          It is unconscionable that athletes who invest their time, talent, love, and grit to play
          organized sports for the masses to enjoy, continue to be subjected to relentless racist
          abuse online. No one should have to endure the mental distress of racial abuse - but it
          persists, unabashedly on social media, where the perpetrators can hide behind a screen.
          These outrageous acts once again reveal the ignorance and insensitivity which permeate
          certain segments of society.
        </Paragraph>

        <Paragraph>
          And while it may take massive undertakings to reign in the culprits, clubs and leagues are
          demanding real and concerted actions from social media companies, to eradicate the use of
          their platforms to commit these vile acts.
        </Paragraph>

        <Paragraph>
          Playaz4Playaz stands in solidarity with the athletic community, especially the clubs
          across the Premier League. English Football League, Women’s Super League and Women’s
          Championship, as they take a stance in protest against the online racist abuse and
          bullying of players. With racism and its damages to the human psyche persisting in society
          today, whether through ignorance or willful intentions, we are committed to doing our part
          to encourage a dynamic climate of racial tolerance as we take our platform from Beta to
          commercial.
        </Paragraph>

        <Paragraph>
          Playaz4Playaz.com embraces the ethos of the sports culture and holds deep admiration for
          the determination with which athletes work to meet their fans expectations, despite
          challenges. We are tapping into the power of technology to empower athletes as they engage
          with their fans, followers and supporters and plan to engage in sustained efforts in
          respective environment which is membership based.
        </Paragraph>
      </Col>
    </Col>
  );
};

export default StopTheHate;
